// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  allowNewRecord: false,
  serverUrl: '/data_app/api',
  authUrl: '/data_app/api/auth/external',
  bnSearchUrl: 'http://102.223.37.162:8316',
  // serverUrl: '/main-server/api',
  // authUrl: 'http://41.207.248.244:5554/api/auth/external',
  // bnSearchUrl: 'http://41.207.248.244:8316',

  passwordResetURL: 'https://backoffice.oasisproducts.ng/login/passwordChange',

  FILE_SERVER: 'https://cac.oasisproducts.ng/file_server_service/edmsapp/',
  commonLinks: {
    publicSearch: 'http://41.207.248.189:7575/home',
    nameReservation: '/name-reservation/new-application',
    preIncorporation: '/dashboard',
    postIncorporation: 'http://41.207.248.189:8888/login',
  },

  localStorageEncryptionKey: 'hmhoAqsXPC6SlMXZlreAPyOTgD7xKt6Mqr2e8soFbJU5QS14cHIpsSJ2AmHveYHH-dQOFMzANuOjKoKfgTIDw05zUi1FUHZxnbZDx6N',

  get baseURL(): string {
    const parsedUrl: URL = new URL(window.location.href);
    return parsedUrl.origin;
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
